"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractPkgsFromNpmLockV2 = void 0;
const utils_1 = require("../../utils");
const extractPkgsFromNpmLockV2 = (pkgLockContent) => {
    return (0, utils_1.parseJsonFile)(pkgLockContent, 'package-lock.json').packages;
};
exports.extractPkgsFromNpmLockV2 = extractPkgsFromNpmLockV2;
//# sourceMappingURL=extract-npm-lock-v2-pkgs.js.map